import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      className="bg-gradient-to-br from-app-page-from to-app-page-to"
      style={{ width: '100%', height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}
    >
      <div className="app-breadcrumb-bar">
        <div className="app-breadcrumb-row">
          <button onClick={() => navigate('/')} className="app-breadcrumb-link">Home</button>
          <span className="app-breadcrumb-sep">›</span>
          <span className="app-breadcrumb-current">Privacy Policy</span>
        </div>
      </div>

      <div className="flex-1 overflow-auto p-3 pb-4 md:p-4 md:pb-4 lg:p-6 lg:pb-6">
        <div className="bg-white rounded-lg shadow-md overflow-hidden">

          <div className="p-4 md:p-6 bg-gradient-to-r from-blue-500 to-blue-600 text-white">
            <div className="flex items-start gap-3">
              <div className="w-9 h-9 rounded-lg bg-white/20 flex items-center justify-center text-lg shrink-0">🔒</div>
              <div className="min-w-0 text-left">
                <h1 className="text-xl md:text-2xl font-bold leading-snug">Privacy Policy</h1>
                <p className="text-app-header-muted text-xs md:text-sm mt-0.5">Last updated: April 2026</p>
              </div>
            </div>
          </div>

          <div className="p-6 md:p-8 text-left">

          <section className="mb-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">1. Introduction</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              ExamMasters ("we", "us", or "our") is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard data when you use our platform at <strong>exammasters.com.au</strong>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">2. Information We Collect</h2>
            <ul className="list-disc list-inside text-sm text-gray-600 leading-relaxed space-y-1">
              <li>Account information (name, email) provided during registration via Auth0.</li>
              <li>Usage data such as courses enrolled, practice attempts, and exam results.</li>
              <li>Payment information processed securely by Stripe — we do not store card details.</li>
              <li>Technical data including IP address, browser type, and device information.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">3. How We Use Your Information</h2>
            <ul className="list-disc list-inside text-sm text-gray-600 leading-relaxed space-y-1">
              <li>To provide and improve our educational services.</li>
              <li>To process payments and manage subscriptions.</li>
              <li>To send you service-related communications (e.g. subscription receipts).</li>
              <li>To analyse usage patterns and improve platform performance.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">4. Data Sharing</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              We do not sell your personal data. We share data only with trusted third-party providers necessary to operate our service (Auth0 for authentication, Stripe for payments, and our hosting provider). These parties are bound by their own privacy policies.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">5. Data Retention</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              We retain your data for as long as your account is active or as required by law. You may request deletion of your account and associated data by contacting us.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">6. Your Rights</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              You have the right to access, correct, or delete your personal data. To exercise these rights, please contact us at <a href="mailto:support@exammasters.com.au" className="text-indigo-600 hover:underline">support@exammasters.com.au</a>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">7. Cookies</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              We use session cookies and local storage to maintain your login state and improve your experience. No third-party advertising cookies are used.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-800 mb-2">8. Contact</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              For privacy-related enquiries, contact us at{' '}
              <a href="mailto:support@exammasters.com.au" className="text-indigo-600 hover:underline">
                support@exammasters.com.au
              </a>.
            </p>
          </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
